import { Container, Row, Col, Button } from 'solid-bootstrap';
import { CreditsURL, PrivacyURL } from '../../env';

export function LoggedOutFooter(props) {
    return <footer class="footer bg-dark text-white mt-auto">
        <Container>
            <p>Timechief only uses essential cookies to provide app functionality.  We do not use your data for advertisement or other marketing purposes.  Usage of the app indicates agreement with our cookies and privacy policy.</p>
            <Row>
            <Col>
                    <p><a href="/"><Button variant="light">Home</Button></a></p>
                </Col>
                <Col>
                    <p><a href={PrivacyURL}><Button variant="light">Privacy policy</Button></a></p>
                </Col>
                <Col>
                    <p><a href={CreditsURL}><Button variant="light">Credits</Button></a></p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p>© Timechief Ltd, 2023</p>
                </Col>
            </Row>
        </Container>
    </footer>
}